import React from "react";

const feedbacks = [
  {
    text: "Amazing team best treatment from the best doctor in the world.",
    name: "Charmi Shah",
    role: "Patient",
    img: "https://randomuser.me/api/portraits/women/75.jpg",
  },
  {
    text: "I went there for a routine procedure but it was quickly determined that I was in persistent A-fib.",
    name: "Daizy Shroff",
    role: "Patient",
    img: "https://randomuser.me/api/portraits/women/65.jpg",
  },
  {
    text: "I usually dread making medical appointments because I’m always put on hold. Here, I could easily see availability slots and got an explicit confirmation!",
    name: "Ricky Martin",
    role: "Patient",
    img: "https://randomuser.me/api/portraits/men/45.jpg",
  },
  {
    text: "I got very good response from this and thanks for changing my new world without glasses.",
    name: "John Duei",
    role: "Patient",
    img: "https://randomuser.me/api/portraits/men/35.jpg",
  },
];

const FeedbackSection = () => {
  return (
    <section className="bg-white w-full py-20">
      <div className="max-w-7xl mx-auto px-6 md:px-12 text-center">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-12">
          Read feedback about our <br /> services and wonderful team!
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {feedbacks.map((f, i) => (
            <div
              key={i}
              className="bg-[#FFF0DC] rounded-2xl p-6 flex flex-col justify-between items-center text-center shadow-sm hover:shadow-md transition"
            >
              <p className="text-gray-700 text-sm mb-6 italic leading-relaxed">
                “{f.text}”
              </p>
              <div className="flex flex-col items-center">
                <img
                  src={f.img}
                  alt={f.name}
                  className="w-12 h-12 rounded-full mb-2 object-cover"
                />
                <h3 className="font-semibold text-gray-900 text-sm">{f.name}</h3>
                <p className="text-gray-600 text-xs">{f.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeedbackSection;
